import React from 'react'
import { Typography, useColorMode } from '@airbus/components-react/components'

const Fieldset = ({
  legend,
  children,
  style,
  ...rest
}: {
  legend?: string | React.ReactNode
  children: React.ReactNode
  style?: React.CSSProperties
}) => {
  const { color } = useColorMode()
  return (
    <fieldset
      {...rest}
      style={{
        ...style,
        borderRadius: 0,
        border: `2px solid ${color.type === 'light' ? color.palette.coolgrey[30] : color.palette.coolgrey[60]}`,
      }}
    >
      {legend && (
        <legend>
          <Typography>{legend}</Typography>
        </legend>
      )}
      {children}
    </fieldset>
  )
}

export default Fieldset
